import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import React from "react";
import { Row } from "react-bootstrap";
import "../../Assets/Styles/pages/uploadImage.scss";

import ButtonRounded from "../Signature/button";

interface SaveModalProps {
  open: boolean;
  handleCompleteEdit: (save: boolean) => void;
}

const SaveModal: React.FC<SaveModalProps> = ({ open, handleCompleteEdit }) => {
  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 800,
      }}
    >
      <Fade in={open}>
        <Row className="model w_30 m-0  py-4 px-2">
          {/* <CancelButton close={() => handleClean()} /> */}
          <Row className="m-0 p-0 d-flex justify-content-center">
            <Row className="d-flex justify-content-center align-items-center productSansBold line_height_100pc text_22">
              Save for All?
            </Row>
            <Row className="d-flex justify-content-center productSans text_15 my-4 line_height_100pc">
              Do you want to save this edited template to all images?
            </Row>
            <Row className="d-flex justify-content-center w_max">
              <ButtonRounded
                onclick={() => {
                  handleCompleteEdit(false);
                }}
                text={"No"}
                style={"w_edit_button bg_batch my-0 mb-0 p-0"}
                parrentStyle={"w-50"}
              />
              <ButtonRounded
                onclick={() => {
                  handleCompleteEdit(true);
                }}
                text={"Yes"}
                style={"w_edit_button  my-0 mb-0 p-0"}
                parrentStyle={"w-50"}
              />
            </Row>
          </Row>
        </Row>
      </Fade>
    </Modal>
  );
};

export default SaveModal;
